<style>
  @media (min-width: 420px) {
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>

<header>
  <slot />
</header>
